import stageNameList from "./revision-number/stage-name-list";

export default [...stageNameList];
